import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLoginNew } from "../../../store/LoginNew/loginNew.slice";
import { setLoginNavigationData } from "../../../store/loginNavigation/LoginNavigation.slice";
import { useNavigate } from "react-router-dom";
import { openSlotCasinoPopUp } from "../../../store/slotCasinoPopUp/slotCasinoPopUp.slice";
import { USER_DATA } from "../../../config/app.config";
import { toastr } from "react-redux-toastr";
import { storeUserData } from "../../../helpers/payloadSetter";

const ContinueGameList = ({ Data, seeAll }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth);
  const [showLoginBtn_At, setShowLoginBtn_At] = useState("");

  let userDetail = localStorage.getItem(USER_DATA);
  let userData = JSON.parse(userDetail);

  const onClickGame = (item, item_index, tab_Index) => {
    if (user) {
      if (userData?.is_demo) {
        toastr.error("", "Please login from your read ID.");
        return;
      }

      if (item?.tested) {
        navigate(`/table-casino-live/${item?.eventName}`);
      } else {
        const gameId = item?.gameId;
        const tableId = item?.tableId || null;

        storeUserData(userData?._id, item);
        navigate(`/casino-live/${gameId}/${tableId}`);
        dispatch(openSlotCasinoPopUp());
      }
    } else {
      setShowLoginBtn_At(`${item.name}_${item_index}_${tab_Index}`);
    }
  };

  const handleLogin = (item) => {
    dispatch(setLoginNew(true));
    if (item?.tested) {
      dispatch(
        setLoginNavigationData({
          page: "table-casino-live",
          ids: [item?.eventName],
        })
      );
    } else {
      dispatch(
        setLoginNavigationData({
          page: "casino-live",
          ids: [item?.gameId, item?.tableId || null],
        })
      );
    }
  };

  return (
    <div
      className={`p-1   grid-cols-3  gap-1.5  ${
        seeAll
          ? "grid md:grid-cols-4 sm:grid-cols-3"
          : "flex grid-rows-1 grid-flow-col"
      }   gap-x-[6px]`}
    >
      {Data.length > 0
        ? Data.map((item, index) => {
            if (
              item?.name == "32 Card B" &&
              window?.location?.hostname?.includes("sbgwinbuzz.in")
            )
              return null;

            return (
              <div
                key={item?.gameId || item?.name}
                className={`relative overflow-hidden ${
                  seeAll
                    ? "w-full"
                    : "min-w-[117px] w-[117px] sm:min-w-[140px] sm:w-[140px] md:min-w-[160px] md:w-[160px]"
                } aspect-[0.85] object-cover rounded-md cursor-pointer`}
                onClick={() => onClickGame(item, index, 0)}
              >
                <img
                  src={
                    item?.image_1 ||
                    item?.image_2 ||
                    item?.image ||
                    item?.img ||
                    (!!item?.images[2]
                      ? item?.images[2]?.url
                      : !!item?.images[1]
                      ? item?.images[1]?.url
                      : item?.images[0]?.url)
                  }
                  alt="Cash or Crash"
                  sizes="(max-width: 600px) 100vw, (max-width: 1200px) 50vw, 625px"
                  className="  transition-all duration-500 ease-in-out active:scale-105 w-full h-full"
                  title="Cash or Crash - Unicon365"
                  btnscontainerclassname="flex w-[108.75px] items-center justify-end gap-[5px]"
                />
              </div>
            );
          })
        : null}
    </div>
  );
};

export default ContinueGameList;
